import { useContext, useEffect, useState } from "react";
import { OneRow, TwoRow } from "../../core/layouts";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import { Text, Spin } from "react_reusable_components";
import useResponsive from "../../core/hooks/useResponsive";
import variables from "../../themes/base/styles/variables";
import { useIntl } from "react-intl";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import MediaService from "../../services/media-service";

const ImagePreviewContainerStyle = {
  imagePreviewContainer: {
    background: variables.whiteSmoke,
    border: `1px solid ${variables.grey4}`,
    marginTop: variables.marginSmallest,
    padding: variables.paddingSmall2,
    overflow: "none",
    width: variables.fullWidth,
  },
  fileNameStyle: {
    fontWeight: variables.fontWeightNormal,
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
  },
  fileSizeStyle: {
    fontWeight: variables.fontWeightNormal,
    fontSize: variables.fontSizeSmallest,
    lineHeight: variables.lineHeightMedium,
    color: variables.grey2,
    marginTop: "0.25rem",
  },
  threeColumnContainerStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    gap: variables.gapMediumSmaller,
  },
  middleSectionStyle: {
    flex: variables.flex1,
  },
  imagePreviewIconStyle: {
    width: variables.imagePreviewWidth,
    height: variables.imagePreviewHeight,
    objectFit: "cover",
  },
};

export default function ImagePreviewContainer({ imageId, setImageUrl }) {
  const responsive = useResponsive();
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const [imageDataUrl, setImageDataUrl] = useState("");
  const intl = useIntl();
  const [imageName, setImageName] = useState("");
  const [imageSize, setImageSize] = useState("");
  const [isImageLoading, setIsImageLoading] = useState(false);

  useEffect(() => {
    if (imageId) {
      setIsImageLoading(true);
      MediaService?.getMediaData({
        loaderDispatch,
        mediaId: imageId,
        intl,
      }).then((res) => {
        setIsImageLoading(false);
        let filename =
          res?.headers["content-disposition"].split("filename=")[1];
        filename = filename.replace(/['"]+/g, "");
        var url = URL.createObjectURL(res?.data);
        setImageName(filename);
        setImageDataUrl(url);
        setImageSize(res?.data?.size);
      });
    }
  }, [imageId]);

  function bytesToMB(bytes) {
    return bytes / (1024 * 1024);
  }

  return (
    <OneRow
      style={{
        ...ImagePreviewContainerStyle.imagePreviewContainer,
        ...(responsive.isMd && { maxWidth: "275px" }),
      }}
      section={
        <ThreeColumn
          style={ImagePreviewContainerStyle.threeColumnContainerStyle}
          leftSection={
            isImageLoading ? (
              <Spin />
            ) : (
              imageDataUrl && (
                <img
                  src={imageDataUrl}
                  style={ImagePreviewContainerStyle.imagePreviewIconStyle}
                  alt="Selected"
                />
              )
            )
          }
          middleSection={
            <TwoRow
              topSection={
                <Text style={ImagePreviewContainerStyle.fileNameStyle}>
                  {imageName}
                </Text>
              }
              bottomSection={
                <Text style={ImagePreviewContainerStyle.fileSizeStyle}>
                  {bytesToMB(imageSize).toFixed(3) + "MB"}
                </Text>
              }
            />
          }
          middleSectionStyle={ImagePreviewContainerStyle.middleSectionStyle}
          rightSection={
            <img
              src="/icons/close.svg"
              alt="Close Icon"
              onClick={() => {
                setImageUrl("");
                setImageDataUrl("");
              }}
            />
          }
        />
      }
    />
  );
}
